import React, { forwardRef } from "react";

const TextField = forwardRef(({
  icon: Icon,
  type = "text",
  value,
  onChange,
  placeholder,
  className = "",
  error = false,
  disabled = false,
  id,
  name,
  ...props
}, ref) => {
  return (
    <div className="relative w-full group">
      {/* Optional Leading Icon */}
      {Icon && (
        <Icon
          className={`absolute left-3.5 top-1/2 -translate-y-1/2 text-lg transition-colors z-10 ${error
              ? "text-red-400"
              : "text-gray-400 group-focus-within:text-emerald-600"
            }`}
          aria-hidden="true"
        />
      )}

      <input
        ref={ref}
        id={id}
        name={name}
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        className={`block w-full appearance-none rounded-lg border bg-white py-3 text-sm text-gray-900 shadow-sm transition-all focus:outline-none disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-500 ${Icon ? 'pl-11 pr-4' : 'px-4'
          } ${error
            ? "border-red-300 placeholder:text-red-300 focus:border-red-500 focus:ring-1 focus:ring-red-500"
            : "border-gray-300 placeholder:text-gray-400 focus:border-emerald-500 focus:ring-1 focus:ring-emerald-500"
          } ${className}`}
        {...props}
      />
    </div>
  );
});

TextField.displayName = "TextField";

export default TextField;